import CourseStructureReducer from './CourseStructureReducer';
export default CourseStructureReducer;
